import React, { useMemo } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../../_metronic/_partials/controls';
import { useKurbanReportUIContext } from './KurbanReportUIContext';
import KurbanReportTable from './kurban-report-table/KurbanReportTable';
import { KurbanReportFilter } from "./kurban-report-filter/KurbanReportFilter";
import { RoleChecker } from '../../../../../RoleChecker';

function KurbanReportCard(props) {

    const kurbanReportUIContext = useKurbanReportUIContext();
    const kurbanReportUIProps = useMemo(() => {
        return {
            newKurbanReportButtonClick: kurbanReportUIContext.newKurbanReportButtonClick,
        };
    }, [kurbanReportUIContext]);

    return (
        <>
            <Card>
                <CardHeader title="Filter Data">
                </CardHeader>
                <CardBody>
                    <KurbanReportFilter />
                </CardBody>

            </Card>
            <Card>
                <CardHeader title="Tabel Data">
                </CardHeader>
                <CardBody>
                    <KurbanReportTable />
                </CardBody>

            </Card>
        </>

    );
}

export default KurbanReportCard;
